export default __webpack_public_path__ + "static/media/edit.d5f8c596.svg";